import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { SignUpForm, type SignUpFormValues } from "./components/SignUpForm";
import { postRodauth, rodauthSuccess } from "@/lib/rodauth";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export default function SignUpPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { refetch } = useCurrentUser();

  const handleSubmit = async (values: SignUpFormValues) => {
    setLoading(true);
    setError(null);

    try {
      const response = await postRodauth("/create-account", {
        email: values.email,
        "email-confirm": values.email,
        password: values.password,
        "password-confirm": values.password,
      });

      const result = await refetch();
      if (result.data?.currentUser) {
        navigate("/dashboard", { replace: true });
        return;
      }

      if (!rodauthSuccess(response)) {
        setError("Não foi possível criar a conta. Verifique os dados.");
      } else {
        setError("Não foi possível criar a conta. Verifique os dados.");
      }
    } catch {
      setError("Erro ao criar conta. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-6 sm:p-12">
        <CardContent className="p-0">
          <h1 className="text-3xl font-light tracking-tight text-primary-950 dark:text-white mb-2">
            CRIAR CONTA
          </h1>
          <p className="text-sm font-light text-primary-600 dark:text-primary-400 mb-8">
            Comece a configurar sua loja
          </p>
          <SignUpForm onSubmit={handleSubmit} loading={loading} error={error} />
        </CardContent>
      </Card>
    </div>
  );
}
